"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.directionVariants = void 0;
var _styledComponents = require("styled-components");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var directionVariants = (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var $direction = _a.$direction;
  switch ($direction) {
    case 'vertical':
      return (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                flex-direction: column;\n            "], ["\n                flex-direction: column;\n            "])));
    default:
    case 'horizontal':
      return (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                flex-direction: row;\n            "], ["\n                flex-direction: row;\n            "])));
  }
});
exports.directionVariants = directionVariants;
var templateObject_1, templateObject_2, templateObject_3;